import 'chartjs-plugin-datalabels';
import { FormatAsCents, FormatAsDollars } from '../../../utils/Helpers/Format';

const chartOptions = ({
  opts,
  rateValue,
  isLowest,
  yAxesLabel,
  savedLabel,
}) => {
  const isMobile = window.innerWidth < 768;

  return {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: 10,
    },
    scales: {
      y: {
        display: true,
        stacked: true,
        gridLines: {
          display: true,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        ticks: {
          callback: function (value) {
            return `$${value.toFixed(0)}`;
          },
          fontSize: 14,
          fontColor: '#000000',
          fontFamily: "Interstate, 'Open Sans'",
          padding: 15,
          maxTicksLimit: 6,
        },
        scaleLabel: {
          display: true,
          labelString: yAxesLabel,
          fontSize: 14,
          fontWeight: 800,
          fontColor: '#262626',
          fontFamily: "Interstate, 'Open Sans'",
        },
      },
      x: {
        gridLines: {
          display: false,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        stacked: true,
        categorySpacing: 10,
        ticks: {
          callback: function (label) {
            let title = opts[label].label;
            if (window.innerWidth < 1260) {
              if (Array.isArray(title)) {
                title = title.join(' ');
              }
              if (/\s/.test(title)) {
                return title.split(' ');
              } else {
                return title;
              }
            } else {
              return title;
            }
          },
          fontSize: 14,
          fontWeight: 800,
          fontColor: '#262626',
          fontFamily: "Interstate, 'Open Sans'",
          autoSkip: true,
          maxRotation: 90,
          minRotation: 0,
          maxTicksLimit: 3,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += FormatAsCents(context.parsed.y);
            }
            return label;
          },
        },
      },
      legend: {
        reverse: true,
        position: 'bottom',
        onClick: function (e) {
          e.stopPropagation();
        },
        labels: {
          fontSize: 14,
          fontColor: '#262626',
          padding: 20,
          fontFamily: "Interstate, 'Open Sans'",
          boxWidth: 20,
        },
      },
      datalabels: {
        formatter: (value, ctx) => {
          if (ctx.datasetIndex !== ctx.chart.data.datasets.length - 1)
            return '';
          return ctx.dataIndex === 0
            ? isLowest
              ? `${FormatAsDollars(rateValue.toFixed(0))} ${savedLabel}`
              : ''
            : opts[ctx.dataIndex].savings && opts[ctx.dataIndex].savings > 0
            ? `${FormatAsDollars(
                opts[ctx.dataIndex].savings.toFixed(0)
              )} ${savedLabel}`
            : '';
        },
        align: 'end',
        anchor: 'end',
        color: (ctx) => {
          return '#142C41';
        },
        font: {
          weight: 400,
          size: isMobile ? 14 : 24,
        },
      },
    },
  };
};

export default chartOptions;
